// FIXME: Must come from DB
// Table: company_targets
// Columns: company_id, valid_from, valid_to, value, currency_id
export function getCompanyTarget(companyId: number): number {
  switch (companyId) {
    case 1: return 150_000;
    case 3: return 100_000;
    case 13: return 4_000_000;
    case 20: return 800_000;
    case 38: return 100_000;
    case 49: return 83_333;
    case 53: return 1_500_000;
    default: return 0;
  }
}

// FIXME: Fetch
export function getCompanyDomain(companyId: number): string {
  switch (companyId) {
    case 1: return "learnster.com";
    case 3: return "revelate.app";
    case 13: return "tendium.com";
    case 20: return "paligo.net";
    default: return "unknown";
  }
}
